var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyDocuments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 78,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.704 15.438c2.452 0 4.44 2.037 4.44 4.55 0 2.512-1.988 4.55-4.44 4.55h-25.37c2.451 0 4.44 2.037 4.44 4.55 0 2.512-1.989 4.55-4.44 4.55h13.953c2.452 0 4.44 2.037 4.44 4.55 0 2.512-1.988 4.55-4.44 4.55h-6.453c-3.092 0-5.598 2.037-5.598 4.55 0 1.675 1.269 3.191 3.806 4.55 2.452 0 4.439 2.037 4.439 4.55 0 2.512-1.987 4.55-4.44 4.55H44.399c-2.452 0-4.44-2.038-4.44-4.55 0-2.513 1.988-4.55 4.44-4.55H19.662c-2.452 0-4.44-2.038-4.44-4.55 0-2.513 1.988-4.55 4.44-4.55h25.37c2.453 0 4.44-2.038 4.44-4.55 0-2.513-1.988-4.55-4.44-4.55H29.176c-2.452 0-4.44-2.038-4.44-4.55 0-2.513 1.988-4.55 4.44-4.55h25.37c-2.452 0-4.44-2.038-4.44-4.55 0-2.513 1.988-4.55 4.44-4.55h62.158zm0 18.2c2.452 0 4.44 2.037 4.44 4.55 0 2.512-1.988 4.55-4.44 4.55-2.452 0-4.44-2.038-4.44-4.55 0-2.513 1.988-4.55 4.44-4.55z",
    fill: "#85B440",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.673 19.979 84.3 54.563l.416 3.47c.134 1.118-.642 2.135-1.732 2.273l-29.13 3.665c-1.091.137-2.084-.658-2.218-1.775l-4.484-37.432a1.015 1.015 0 0 1 .866-1.136l.01-.002 2.417-.277 29.228-3.37zM52.4 23.124l2.282-.262-2.282.262z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m52.399 23.124 2.282-.262m24.992-2.883L84.3 54.563l.416 3.47c.134 1.118-.642 2.135-1.732 2.273l-29.13 3.665c-1.091.137-2.084-.658-2.218-1.775l-4.484-37.432a1.015 1.015 0 0 1 .866-1.136l.01-.002 2.417-.277 29.228-3.37z",
    stroke: "#85B440",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m78.414 22.154 4.188 31.343.377 3.144c.121 1.013-.572 1.934-1.55 2.057L55.344 61.98c-.976.123-1.866-.598-1.988-1.611l-4.054-33.837a1.015 1.015 0 0 1 .866-1.137l3.227-.406",
    fill: "#85B440",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.945 13.479H58.284c-.378 0-.72.156-.968.41-.247.254-.4.604-.4.991v38.743c0 .388.153.738.4.992.248.253.59.41.967.41h29.349c.378 0 .72-.157.967-.41.248-.254.401-.604.401-.992V21.73a1.42 1.42 0 0 0-.401-.991l-6.687-6.85a1.351 1.351 0 0 0-.967-.41z",
    fill: "#fff",
    stroke: "#85B440",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.165 14.066v5.912c0 .845.668 1.53 1.493 1.53h3.946M62.263 47.507h12.933m-12.933-26h12.933-12.933zm0 6.118h21.39-21.39zm0 6.627h21.39-21.39zm0 6.627h21.39-21.39z",
    stroke: "#85B440",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDocuments);
export default __webpack_public_path__ + "static/media/EmptyDocuments.487f895fc4d578337858d22463ebc3a3.svg";
export { ForwardRef as ReactComponent };